export class PurposeModel {
    code: string;
    description: string;
    id: string;
    name: string;
}


// WEBPACK FOOTER //
// ./src/app/_models/products/PurposeModel.ts